export default __webpack_public_path__ + "static/media/calendar.e7ddc5a7.svg";